<template>
  <div class="dashboard-index">
    <page-header :title="'Welcome ' + $auth.user.name">
      <div slot="sub-title">
        <fa icon="user" />
        Dashboard
      </div>
      <div slot="controls" class="control-flex">
          <saldo />
      </div>
    </page-header>
<!-- TODO: Show metrics
    <div class="body-padding">
      <el-row :gutter="20" type="flex" justify="center">
        <el-col :lg="12" :sm="24" class="status-container">
          <stat-card title="Total litres" stat="+ 7621" :transparent="true" />
          <stat-card title="Total transactions" stat="+ 93" :transparent="true" />
          <stat-card title="Preferred gas" stat="Air" :transparent="true"/>
        </el-col>
      </el-row>
    </div>
    -->

    <el-row :gutter="20" class="body-padding">
      <el-col :xs="24" :lg="8">
        <el-card class="fty-padding">
          <h1 class="title">My stations</h1>
          <station
            class="my-station-item"
            v-for="station in userStations"
            :key="station.id" :station="station"
            :selected="false"
            noStatus
            @highlight="gotoStation(station)" />
        </el-card>
        <el-card class="fty-padding margin-top" v-if="user.autoRefillSource">
          <auto-refill-status
            :status="user.autoRefillSource !== null"
            :saldo="parseInt($root.saldoDisplay.base)"
            :minimum="user.autoRefillMinimum"
            :amount="user.autoRefillAmount" />
        </el-card>
      </el-col>
      <el-col :xs="24" :lg="16">
        <el-card class="fty-padding">
          <h1 class="title">Latest 10 transactions</h1>
          <transactions :api="$api.user($auth.user.id).transactions" :limit="10" />
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import Transactions from '@/components/dashboard/transactions/Transactions'
import StatCard from '@/components/shared/StatCard'
import Saldo from '@/components/shared/SaldoValue'
import AutoRefillStatus from '@/components/dashboard/saldoAndCredit/auto-refill/AutoRefillStatus'
import Station from '@/components/dashboard/stations/Station'

export default {
  name: 'DashboardIndex',
  components: { Transactions, StatCard, Saldo, AutoRefillStatus, Station },
  data () {
    return {
      loading: true,
      user: {}
    }
  },
  computed: {
    userStations () {
      let stations = this.$root.userOrganizations.map(item => {
        item.organization.stations.map(station => station.organization = { name: item.organization.name })
        return item.organization.stations
      })
      return [].concat(...stations)
    }
  },
  methods: {
    async getUser () {
      const response = await this.$http.get(this.$api.users.get(this.$auth.user.id))
      this.$root.saldo = response.data.saldo
      this.$root.currency = response.data.currency.name
      this.user = response.data
      this.loading = false
    },
    gotoStation (station) {
      this.$router.push({ name: 'stations', query: { id: station.id } })
    }
  },
  created () {
    this.getUser()
  }
}
</script>

<style lang="scss" scoped>

  .less-padding {
    padding: 20px; 

    @include breakpoint (xs) {
      padding: 0px 20px;
    }
  }

  .control-flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .margin-top {
    margin-top: 20px;

    @include breakpoint (xs) {
      margin-top: 0px;
    }
  }

  .my-station-item {
    margin-left: -20px;
  }

  .less-padding-bottom {
    padding-bottom: 25px;
  }

  .status-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 50px 20px 0px 20px;
    flex-wrap: wrap;

    @include breakpoint (xs) {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/index/DashboardIndex.vue